import { MediaModel } from '../models/media.model';
import { computed, Ref } from 'vue';
import { ScanningStatusEnum } from '../enums/scanningStatus.enum';
import { mediaTypes } from '../enums/mediaTypes';
import i18n from '../locales/i18n';

export const useMediaScan = (media: Ref<MediaModel>) => {
  const scanningStatus = computed(() => media.value.file?.scanningStatus || null);

  const scanningText = computed(() => {
    const mediaType = media.value.mediaType;

    if (scanningStatus.value === ScanningStatusEnum.PROCESSING) {
      switch (mediaType) {
        case mediaTypes.IMAGE:
          return i18n.t('file.file_scan_processing_image');
        case mediaTypes.VIDEO:
          return i18n.t('file.file_scan_processing_video');
        case mediaTypes.SOUND:
          return i18n.t('file.file_scan_processing_audio');
        default:
          return null;
      }
    }

    if (scanningStatus.value === ScanningStatusEnum.BLOCKED) {
      switch (mediaType) {
        case mediaTypes.IMAGE:
          return i18n.t('file.file_scan_blocked_image');
        case mediaTypes.VIDEO:
          return i18n.t('file.file_scan_blocked_video');
        case mediaTypes.SOUND:
          return i18n.t('file.file_scan_blocked_audio');
        default:
          return null;
      }
    }

    return null;
  });

  const isMediaDisabled = computed(
    () => scanningStatus.value === ScanningStatusEnum.PROCESSING || scanningStatus.value === ScanningStatusEnum.BLOCKED
  );

  return {
    scanningText,
    scanningStatus,
    isMediaDisabled,
  };
};
